import React from 'react';

// `locked` blurs + disables the step's controls (header stays sharp) until the previous step is done.
export function SetupStepCard({ step, title, children, isDarkMode, locked }) {
  return (
    <div className={`rounded-2xl border shadow-sm p-6 ${isDarkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200'}`}>
      <div className="flex items-baseline gap-2 mb-4">
        <span className={`text-xs font-bold uppercase tracking-wide ${isDarkMode ? 'text-blue-400' : 'text-blue-600'}`}>Step {step}</span>
        <h3 className={`text-base font-bold ${isDarkMode ? 'text-slate-100' : 'text-slate-900'}`}>{title}</h3>
        {locked && (
          <span className={`text-xs font-medium italic ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
            complete the previous step first
          </span>
        )}
      </div>
      <div
        aria-hidden={locked || undefined}
        className={`transition-[filter,opacity] duration-300 ${locked ? 'blur-[2px] opacity-60 pointer-events-none select-none' : ''}`}
      >
        {children}
      </div>
    </div>
  );
}

export function SquareOptionCard({ value, label, Icon, description, selected, onSelect, isDarkMode }) {
  return (
    <button
      type="button"
      onClick={() => onSelect(value)}
      aria-pressed={selected}
      className={`flex-1 max-w-[220px] aspect-square flex flex-col items-center justify-between text-center rounded-2xl border-2 p-5 transition-colors ${
        selected
          ? (isDarkMode ? 'border-blue-400 bg-blue-400/10' : 'border-blue-500 bg-blue-500/5')
          : (isDarkMode ? 'border-slate-700 bg-slate-900/40 hover:border-slate-600' : 'border-slate-200 bg-slate-50 hover:border-slate-300')
      }`}
    >
      <div className="flex-1 flex flex-col items-center justify-center gap-2">
        <Icon size={36} className={selected ? (isDarkMode ? 'text-blue-400' : 'text-blue-600') : (isDarkMode ? 'text-slate-400' : 'text-slate-500')} />
        <span className={`text-sm font-bold ${isDarkMode ? 'text-slate-100' : 'text-slate-900'}`}>{label}</span>
      </div>
      {description && (
        <p className={`text-[11px] leading-snug ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{description}</p>
      )}
    </button>
  );
}
